import Http from "../controllers/Http";

export default class IntegracaoIaService {
    static getIntegracao(callback) {
        Http.getInstanceAppJson()
            .get("/mcp/integracao")
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }

    static salvarIntegracao(body, callback) {
        Http.getInstanceAppJson()
            .post("/mcp/integracao", body)
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }

    static getConexoes(callback) {
        Http.getInstanceAppJson()
            .get("/mcp/conexoes")
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }

    static revogar(uid, callback) {
        Http.getInstanceAppJson()
            .post("/mcp/conexoes/revogar/" + uid, {})
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }

    static getAtividade(callback) {
        Http.getInstanceAppJson()
            .get("/mcp/atividade")
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }

    static getConsentimento(pedido, callback) {
        Http.getInstanceAppJson()
            .get("/mcp/consentimento/" + encodeURIComponent(pedido))
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }

    static postConsentimento(pedido, body, callback, configRequest) {
        Http.getInstanceAppJson(configRequest)
            .post("/mcp/consentimento/" + encodeURIComponent(pedido), body)
            .then((dados) => callback(dados))
            .catch((e) => callback(null, e));
    }
}
